export function forgeTestId(
  testId: string | null | undefined,
  suffix: string | null | undefined,
): string | undefined {
  return testId && suffix ? `${testId}-${suffix}` : undefined;
}
